import { AnonymousSubscription } from "rxjs/Subscription";
import Firehose from "./LogLibraries/Firehose";
import * as _ from "lodash";
import URLHelper from "./URLHelper";
const DEFAULT_STREAM = "ppl-mathfluency-logs";
export default class LogHelper {
  protected static firehoseClient = new Firehose();
  protected static logsCollected: {} = {};
  protected static logEventSubscription: AnonymousSubscription;
  protected static streamName;
  constructor() {
    LogHelper.initFirehose(DEFAULT_STREAM);
  }
  public static initFirehose(streamName: string): void {
    LogHelper.streamName = streamName;
    LogHelper.firehoseClient.init(streamName);
  }
  public static async sendLogs(): Promise<{}> {
    console.log(
      "sending logs to ",
      LogHelper.streamName,
      " stream :",
      LogHelper.getFinalLog(LogHelper.logsCollected)
    );
    if (!LogHelper.streamName) {
      console.warn("stream name is not set for logging");
    }
    if (URLHelper.getUrlParams()["mode"] !== "dev") {
      LogHelper.firehoseClient.put(
        LogHelper.getFinalLog(LogHelper.logsCollected)
      );
    } else {
      console.log("Not posting logs to server in development mode");
    }
    LogHelper.logsCollected = {};
    return {};
  }

  public static clearCollectedLogs(): void {
    LogHelper.logsCollected = {};
  }

  private static getFinalLog(logObj: any): any {
    let urlParams = URLHelper.getUrlParams();
    if (urlParams.params && urlParams.params.logParams) {
      _.assign(logObj, urlParams.params.logParams);
    }
    return logObj;
  }

  public static collectLog(key: string, value: any): void {
    LogHelper.logsCollected[key] = value;
  }

  public static collectMultipleLogs(logObj: any): void {
    let linkLog = {
      c_link: window.location.href
    };
    LogHelper.logsCollected = _.assign(LogHelper.logsCollected, logObj, linkLog);
  }
}
